import React, { useCallback, useState } from 'react';
import CircularAcronyms from '../../../../component/circular-acronyms/circular-acronyms';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import ThreeDots from '../../../../assets/icons/three-dots.svg';
import DropDownList, {
  ItemType,
} from '../../../../component/ui/drop-down-list/drop-down-list';
import Expandable from '../../../../component/expandable/expandable';
import { Dialog } from 'primereact/dialog';
import { FindUser } from '../../../find-user-page/find-user';
import { UserSummaryType } from '../../../../api/types/user/user-summary.type';
import globalProgramStore from '../../../../stores/program-store';
import { addNewCourseLectures } from './add-new-course-lectures';
import { removeLecturerFromCourseOperation } from '../operation/remove-lecturer-from-course-operation';
import globalCourseStore from '../../../../stores/global-course-store';
import { UserType } from '../../../../api/types/user/user-type';
import { UserPageDialog } from '../../../../component/ui/search-users/user-page-dialog/user-page-dialog';
import { LecturerType } from '../../../../api/types/programs/course/lecturers/course-lecturer';
import { Button } from 'primereact/button';
import { PhoneNumberComponent } from '../../../../utils/international-to-israeli';

export interface TeachingStaffDatamodel extends LecturerType {
  isMajorTeacher: boolean;
}

const TeachingStaff: React.FC<{
  staff: LecturerType[];
  isProfessor: boolean;
}> = ({ staff, isProfessor }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [selectedStaff, setSelectedStaff] = useState<UserSummaryType>();
  const [addLectureDialogIsActive, setAddLectureDialogIsActive] =
    useState<boolean>(false);
  const [deletingLecturerId, setDeletingLecturerId] = useState<number | null>(
    null,
  );

  const threeDotsItems = [{ itemType: ItemType.ADD }];
  const handleThreeDotsClick = useCallback(
    async (index: number, type: ItemType) => {
      if (index === 0) {
        setAddLectureDialogIsActive(true);
      }
    },
    [],
  );

  const handleOnApprove = async (
    selectedUsers: UserSummaryType[],
    setLoading: (loading: boolean) => void,
  ) => {
    console.log(`XXXX handleOnApprove: ${JSON.stringify(selectedUsers)}`);
    const programId = globalProgramStore.getCurrentId();
    const courseId = globalCourseStore.getCurrentCourse()?.details?.id;
    await addNewCourseLectures(
      programId,
      courseId,
      selectedUsers,
      setLoading,
      setAddLectureDialogIsActive,
    );
  };

  const handleRemoveLecturer = async (lecturerId: number) => {
    const programId = globalProgramStore.getCurrentId();
    const courseId = globalCourseStore.getCurrentCourse()?.details?.id;
    await removeLecturerFromCourseOperation(
      programId,
      courseId,
      lecturerId,
      setDeletingLecturerId,
    );
  };

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className={'general-course-page-card'}>
        <div
          className={'general-course-page-card-row'}
          style={{ justifyContent: 'space-between' }}
        >
          <div className={'general-course-page-card-title'}>סגל</div>
          {!isProfessor && (
            <Button
              icon="pi pi-plus"
              rounded
              style={{ height: '30px', width: '30px' }}
              tooltip="להוספת מרצה"
              aria-label="Add"
              visible={!isProfessor}
              onClick={() => setAddLectureDialogIsActive(true)}
            />
            /*<Expandable
              makeAbsolute={true}
              displayChevron={false}
              title={'Title'}
              top={
                <img
                  onClick={() => {
                    // TODO
                  }}
                  height={15}
                  src={ThreeDots}
                />
              }
              bottom={
                <DropDownList
                  onClick={handleThreeDotsClick}
                  items={threeDotsItems}
                />
              }
            ></Expandable>*/
          )}
        </div>

        <div
          className={
            'general-course-page-card-line general-course-page-card-row-height-space'
          }
        ></div>

        {staff.map((item) => {
          return (
            <div
              style={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'row',
                marginTop: 20,
                justifyContent: 'space-between',
              }}
            >
              <div
                className={'general-course-page-card-row'}
                onClick={() => !isProfessor && setSelectedStaff(item)}
              >
                <CircularAcronyms
                  text={item.firstName[0] + item.lastName[0]}
                  width={45}
                  height={45}
                  imageUrl={item.fileUrl}
                />
                <div style={{ width: 10 }} />
                <div className={'general-course-page-card-column'}>
                  <div style={{ fontWeight: 'bold', fontSize: 16 }}>
                    {item.firstName} {item.lastName}
                  </div>
                  {/*<div style={{ color: '#6A6A6A', fontSize: 14 }}>
                    {item.isMajorTeacher ? 'מרצה עיקרי' : 'מרצה משני'}
                  </div>*/}
                  <div style={{ color: '#6A6A6A', fontSize: 13, marginTop: 4 }}>
                    ת.ז: {item.nationalId}
                  </div>
                  <div style={{ color: '#6A6A6A', fontSize: 13, marginTop: 2 }}>
                    טלפון:{' '}
                    {<PhoneNumberComponent phoneNumber={item.phoneNumber} />}
                  </div>
                  <div style={{ color: '#6A6A6A', fontSize: 13, marginTop: 2 }}>
                    דוא"ל: {item.email}
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'end',
                }}
              >
                <div>
                  {!isProfessor && (
                    <Button
                      icon="pi pi-trash"
                      text
                      severity="danger"
                      tooltip={'הסרת מרצה מהקורס'}
                      loading={deletingLecturerId === item.id}
                      disabled={deletingLecturerId !== null}
                      onClick={() => {
                        handleRemoveLecturer(item.id);
                      }}
                    />
                    /*<Expandable
                      makeAbsolute={true}
                      displayChevron={false}
                      title={'Title'}
                      top={
                        <img
                          onClick={() => {
                            // TODO
                          }}
                          height={15}
                          src={ThreeDots}
                        />
                      }
                      bottom={
                        <DropDownList
                          onClick={handleThreeDotsClick}
                          items={[{ itemType: ItemType.DELETE }]}
                        />
                      }
                    ></Expandable>*/
                  )}
                </div>
                {/*<div className={'general-course-page-card-row-text-bold'}>
                  {item.scheduledTeachingHours}/{item.completedTeachingHours}{' '}
                  שעות הוראה
                </div>*/}
              </div>
            </div>
          );
        })}

        <div className={'general-course-page-card-row-height-space'}></div>
      </div>
      <Dialog
        header="הוספת מרצים לקורס"
        visible={addLectureDialogIsActive}
        style={{
          width: '800px',
          height: '85vh',
          backgroundColor: 'white',
          padding: '8px',
          borderRadius: '8px',
        }}
        onHide={() => {
          setAddLectureDialogIsActive(false);
        }}
      >
        <FindUser role={UserType.LECTURER} onApprove={handleOnApprove} />
      </Dialog>

      <UserPageDialog
        userRole={UserType.LECTURER}
        selectedUser={selectedStaff}
        setSelectedUser={setSelectedStaff}
        closeDialog={() => setSelectedStaff(undefined)}
        onHide={() => setSelectedStaff(undefined)}
      />
    </div>
  );
};

export default TeachingStaff;
